// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'messages'

/**
 * Message Model Interface (auto-generated from Drizzle schema)
 */
export interface MessageModel {
  id: string
  orgId: string
  workspaceId?: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  conversationId: string
  role: string
  content: string
  toolCalls?: unknown[]
  mentions?: Record<string, unknown>[]
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    orgId: {
      type: 'string',
      maxLength: 100,
    },
    workspaceId: {
      type: 'string',
      maxLength: 100,
    },
    userId: {
      type: 'string',
      maxLength: 100,
    },
    createdAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    metadata: {
      type: 'object',
    },
    extended: {
      type: 'object',
    },
    conversationId: {
      type: 'string',
      maxLength: 100,
    },
    role: {
      type: 'string',
      maxLength: 50,
    },
    content: {
      type: 'string',
      maxLength: 100000,
    },
    toolCalls: {
      type: 'array',
      items: {},
    },
    mentions: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          type: {
            type: 'string',
            maxLength: 50,
          },
          identifier: {
            type: 'string',
            maxLength: 200,
          },
          teamMemberId: {
            type: 'string',
            maxLength: 100,
          },
          userId: {
            type: 'string',
            maxLength: 100,
          },
          position: {
            type: 'integer',
            minimum: 0,
            maximum: 999999,
            multipleOf: 1,
          },
        },
        required: ['type', 'identifier', 'position'],
      },
    },
    tenantId: {
      type: 'string',
      maxLength: 100,
    },
  },
  required: ['id', 'orgId', 'createdAt', 'updatedAt', 'conversationId', 'role', 'content'],
  indexes: [
    ['conversationId', 'createdAt'],
    ['orgId', 'createdAt'],
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
